/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import { theme } from '../../styles/theme';

/* ============================================
   FORM CONTAINER
   ============================================ */
export const FormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  gap: ${theme.spacing[6]};
`;

/* ============================================
   VERIFICATION STEP
   ============================================ */
export const VerificationStepWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing[6]};
  align-items: stretch;
`;

export const VerificationStepDescriptionContainer = styled.div`
  width: 100%;
  background-color: ${theme.colors.bgGray};
  border-radius: ${theme.radius.lg};
  padding: ${theme.spacing[3]} ${theme.spacing[3]} ${theme.spacing[6]} ${theme.spacing[3]};
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing[3]};
`;

export const VerificationStepDescriptionTitle = styled.h3`
  color: ${theme.colors.black};
  font-family: ${theme.fontFamily.base};
  font-size: ${theme.fontSize.base};
  font-style: normal;
  font-weight: ${theme.fontWeight.semibold};
  line-height: 24px;
  margin: 0;
`;

export const VerificationStepDescription = styled.p`
  font-size: ${theme.fontSize.sm};
  color: ${theme.colors.textGray};
  text-align: left;
  font-family: ${theme.fontFamily.base};
  margin: 0;
`;

export const VerificationEmail = styled.span`
  font-weight: ${theme.fontWeight.medium};
  color: ${theme.colors.text};
`;

export const VerificationStepCodeContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing[10]};
`;

export const VerificationStepCodeInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing[6]};
`;

export const VerificationStepVerifyingText = styled.p`
  font-size: ${theme.fontSize.sm};
  color: ${theme.colors.textSecondary};
  text-align: center;
  font-family: ${theme.fontFamily.base};
  margin: 0;
`;

export const VerificationStepResendContainer = styled.div`
  width: 100%;
  font-size: ${theme.fontSize.sm};
  text-align: center;
  color: ${theme.colors.textSecondary};
  font-family: ${theme.fontFamily.base};
`;

export const VerificationStepResendButton = styled.button`
  color: ${theme.colors.text};
  font-weight: ${theme.fontWeight.medium};
  transition: all ${theme.transition.base};
  background: none;
  border: none;
  padding: 0;
  font-family: ${theme.fontFamily.base};
  font-size: ${theme.fontSize.sm};

  &:not(:disabled) {
    cursor: pointer;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

/* ============================================
   EMAIL VERIFICATION STATUS
   ============================================ */
export const VerifyStatusContainer = styled.div<{ $stretch?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: ${(props: { $stretch?: boolean }) => (props.$stretch ? 'stretch' : 'center')};
  justify-content: center;
  gap: ${theme.spacing[6]};
`;

export const VerifyStatusSpinner = styled.div`
  border-radius: ${theme.radius.full};
  height: ${theme.sizes.verifyCode};
  width: ${theme.sizes.verifyCode};
  border-bottom: 2px solid ${theme.colors.primary};
`;

export const VerifyStatusSuccessContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${theme.spacing[4]};
`;

export const VerifyStatusSuccessIcon = styled.div`
  width: ${theme.sizes.verifyIcon};
  height: ${theme.sizes.verifyIcon};
  border-radius: ${theme.radius.full};
  background-color: ${theme.colors.successBg};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const VerifyStatusSuccessIconSvg = styled.div`
  width: ${theme.sizes.verifyIconInner};
  height: ${theme.sizes.verifyIconInner};
  color: ${theme.colors.successDark};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const VerifyStatusTextCenter = styled.p`
  text-align: center;
  font-family: ${theme.fontFamily.base};
  font-size: ${theme.fontSize.sm};
  color: ${theme.colors.text};
  margin: 0;
`;

/* ============================================
   UTILITY CLASSES
   ============================================ */
export const Hidden = styled.div`
  display: none;
`;

export const VisuallyHidden = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
`;
